<script lang="ts" setup>
import { Toaster as Sonner, type ToasterProps } from 'vue-sonner'

const props = defineProps<ToasterProps>()
</script>

<template>
  <Sonner
    class="toaster group"
    v-bind="props"
    :toast-options="{
      classes: {
        toast: 'group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg',
        description: 'group-[.toast]:text-muted-foreground',
        // vue-sonner styles [data-button] with a selector of the same
        // specificity that loads later, so these need `!` to apply at all.
        actionButton:
          'group-[.toast]:!h-7 group-[.toast]:!rounded-md group-[.toast]:!bg-primary group-[.toast]:!px-3 group-[.toast]:!text-[12.5px] group-[.toast]:!font-semibold group-[.toast]:!text-primary-foreground group-[.toast]:!shadow-sm group-[.toast]:transition-colors group-[.toast]:hover:!bg-primary/90',
        cancelButton:
          'group-[.toast]:!h-7 group-[.toast]:!rounded-md group-[.toast]:!bg-muted group-[.toast]:!px-3 group-[.toast]:!text-[12.5px] group-[.toast]:!font-semibold group-[.toast]:!text-muted-foreground',
      },
    }"
  />
</template>
